import React from "react";
import "./style.scss";
import Sidebar from "../Components/Sidebar";
import Dashboard from "../Pages/Dashboard";
import Warranty from "../Pages/Warranty";
import Login from "../Pages/Login";
import { createHashRouter, Outlet, RouterProvider } from "react-router-dom";
import Superadmin from "../Pages/Superadmin";
import Service from "../Pages/Superadmin/Service";
import Bike from "../Pages/Superadmin/bike";
import ResetPassword from "../Pages/ResetPassword/ResetPassword";
import ForgotPassword from "../Pages/ForgotPassword/ForgotPassword";

const ManagerLayout = () => {
  return (
    <div className="layout-container">
      <div className="sidebar">
        <Sidebar />
      </div>
      <div className="content">
        <Outlet />
      </div>
    </div>
  );
};

const Router = createHashRouter([
  {
    path: "/",
    element: <ManagerLayout />,
    children: [
      {
        path: "",
        element: <Dashboard />,
      },
      {
        path: "warranty",
        element: <Warranty />,
      },
    ],
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/forgotPassword",
    element: <ForgotPassword />,
  },
  {
    path: "/resetPassword",
    element: <ResetPassword />,
  },
  {
    path: "/superadmin",
    element: <Superadmin />,
    children: [
      {
        path: "service",
        element: <Service />,
      },
      {
        path: "bike",
        element: <Bike />,
      },
    ],
  },
]);

const Layout = () => {
  return <RouterProvider router={Router} />;
};

export default Layout;
